import { OneTimePurchasePlanCadence, PlanCadence } from '@/store/purchaseParams/types';

export interface Coupon {
	id: string;
	duration: string;
	percent_off?: number;
	amount_off?: number;
	valid: boolean;
	max_redemptions?: number;
	times_redeemed?: number;
}

export type Coupons = Partial<{
	[key in PlanCadence | OneTimePurchasePlanCadence]: Coupon;
}>;

export interface PriceOptions {
	monthly: number;
	yearly: number;
	quarterly: number;
	lifetime: number;
	family: number;
	currency: string;
	amount_due?: number;
	country?: string;
	oneTimePurchases?: Partial<Record<OneTimePurchasePlanCadence, number>>;
}

export interface PricingFormat {
	format?: string;
	seperator?: string;
	currency: string;
}

export interface Prices {
	current: PriceOptions;
	original: PriceOptions;
	coupons: Coupons;
	coupon?: Coupon;
	pricing_format: PricingFormat;
}

export const SET_PRICES = 'SET_PRICES';
